import type { AxiosResponse, Method } from 'lib/axios';
import { APICallV4 } from 'reactApp/api/APICall';
import type { WeblinksIncomingRemoveApiResponse, WeblinksIncomingRemoveParams } from 'reactApp/modules/incomingPublic/incomingPublic.types';

const method = 'weblinks/email/access/available/remove';

class WeblinksIncomingRemoveAPIV4Call extends APICallV4 {
    _method = method;
    _type: Method = 'post';
}

export const weblinksIncomingRemoveApiCall = (
    params: WeblinksIncomingRemoveParams
): Promise<AxiosResponse<WeblinksIncomingRemoveApiResponse>> => {
    return new WeblinksIncomingRemoveAPIV4Call().makeRequest(params);
};
